/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorYouplay from 'base/components/labrador/Youplay';

export const DynamicLabradorYouplay: typeof LabradorYouplay = (props) => {
    return <ErrorBoundary><LabradorYouplay {...props} /></ErrorBoundary>;
}
export type DynamicLabradorYouplayProps = PropsFromComponent<typeof LabradorYouplay>;
